module.exports = __webpack_public_path__ + "98aa204d870053f0054ace1c5517dc00.pdf";